import { useCallback, useEffect, useRef } from 'react';

export default function useDebouncedBoundaryWrites() {
  const pending = useRef(new Map());
  const flush = useCallback(async (key) => {
    const entry = pending.current.get(key);
    if (!entry) return undefined;
    clearTimeout(entry.timer);
    pending.current.delete(key);
    return entry.write();
  }, []);
  const schedule = useCallback((key, write, delay = 700) => {
    const previous = pending.current.get(key);
    if (previous) clearTimeout(previous.timer);
    const entry = { write };
    entry.timer = setTimeout(() => flush(key), delay);
    pending.current.set(key, entry);
  }, [flush]);
  const flushAll = useCallback(() => Promise.all([...pending.current.keys()].map(flush)), [flush]);
  useEffect(() => () => { pending.current.forEach(({ timer }) => clearTimeout(timer)); }, []);
  return { schedule, flush, flushAll };
}
